import BaseActions from './../../base/actions'

export default BaseActions({module: 'alertEditing'}, {
  //
})
